import React from 'react';

import { FilePickerItem } from '../../styles';

import { ErrorText } from '../../../_common/Controller/components/ControllerError/ControllerError';

export interface FilesErrorsItemProps {
  error?: string;
}

function FilesErrorsItem({ error }: FilesErrorsItemProps) {
  if (error) {
    return (
      <FilePickerItem>
        <ErrorText>{error}</ErrorText>
      </FilePickerItem>
    );
  }

  return null;
}

export default FilesErrorsItem;
